import React, { useEffect, useState } from 'react'
import axios from 'axios'

import Panel from '../ui/Panel'
import Btn from '../ui/Btn'
import FileUpload from './FileUpload'
import ChallengeLang from './ChallengeLang'
import ChallengeVideos from './ChallengeVideos'
import ChallengeUsers from './ChallengeUsers'
import './challenges.css'

/*
 * THE CONTENT RECORD — challenge, plain post or sponsor item.
 *
 * GET    admin/challenges/:id      load
 * GET    admin/sports              the sport list
 * POST   admin/challenges          save (the whole record object)
 * DELETE admin/challenges/:id      delete
 * All four are untouched: same URLs, same payload, same headers, same reading
 * of the answers.
 *
 * The screen is now a stack of panels instead of one long Bootstrap form:
 * the record itself, its artwork, its languages, its videos and — for a real
 * challenge — the submissions. alert() and window.confirm() are gone; the
 * server's message lands in an inline note and deleting asks in the page.
 *
 * One deliberate flow change: saving an EXISTING record no longer throws you
 * back to the list. The panels below the form (languages, videos, submissions)
 * are the reason anyone opens this screen twice, and being ejected from them
 * after every save was the single most expensive thing about the old form. A
 * NEW record still returns to the list exactly as before, because there is
 * nothing below it to stay for.
 */

const val=(v)=>(v===undefined || v===null ? '' : v)

export default function ChallengeForm(props) {

  const [record,setRecord]=useState({})
  const [isLoading,setIsLoading]=useState(false)
  const [sports,setSports]=useState([])
  const [note,setNote]=useState(null)
  const [confirming,setConfirming]=useState(false)
  const [saving,setSaving]=useState(false)


  useEffect(()=>{
    loadData(props.id)
    loadSports()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[props.id])

  const loadData=(id)=>{
    setIsLoading(true)
    if (id!=0){
      axios.get(process.env.REACT_APP_API_SERVER+'admin/challenges/'+id,{
        headers: {
            'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
            }
        })
      .then(res=>{
          //console.log(res.data.results)
        setRecord(res.data.results)

        setIsLoading(false)

      }).catch(err=>{
          setIsLoading(false)
          setNote({tone:'crit',text:'Η εγγραφή δεν φορτώθηκε. Δοκιμάστε ξανά.'})
      })
    }else{
      setRecord({
        id: 0,
        IsActive:1,
        Descr:'',
        IsChallenge:0
      })
      setIsLoading(false)
    }
  }

  const loadSports=()=>{
    setIsLoading(true)
    axios.get(process.env.REACT_APP_API_SERVER+'admin/sports',{
      headers: {
          'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
          }
      })
    .then(res=>{
       // console.log(res.data.results)
      setSports(res.data.results)
      setIsLoading(false)

    }).catch(err=>{
        setIsLoading(false)
        console.log(err)
    })
  }

  const save=(e)=>{
    e.preventDefault()
    setNote(null)
    setSaving(true)

    const obj={...record}
    axios.post(process.env.REACT_APP_API_SERVER+'admin/challenges',obj,{
      headers: {
          'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
          }
      })
    .then(res=>{
      setSaving(false)
      if (props.id==0){
        props.showForm(0,false)
      }else{
        setNote({tone:'good',text:res.data.msg})
      }
    }).catch(err=>{
      setSaving(false)
      setNote({tone:'crit',text:'Υπήρξε ένα πρόβλημα, παρακαλώ προσπαθήστε ξανά'})
    })
  }

const deleteRecord=()=>{
      setConfirming(false)
      setNote(null)
      axios.delete(process.env.REACT_APP_API_SERVER+'admin/challenges/'+props.id,{
          headers: {
              'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
              }
          })
        .then(res=>{
          if (res.data.err==0){
              props.loadData()
             props.showForm(0,false)
          }else{
            setNote({tone:'crit',text:res.data.msg})
          }


      }).catch(err=>{
        setNote({tone:'crit',text:'Υπήρξε ένα πρόβλημα, παρακαλώ προσπαθήστε ξανά'})
      })
}



const sportsList=(Array.isArray(sports) ? sports : []).map(item=>{
  return(
    <option key={item.SportID} value={item.SportID}>{item.SportName}</option>
  )
})

const isChallenge=record.IsChallenge==1

  return (
    <div className="chx-page">

      <Panel
        title={props.id!=0 ? 'Στοιχεία' : 'Νέα καταχώρηση'}
        subtitle={isChallenge ? 'Challenge' : record.IsChallenge==2 ? 'Χορηγός' : 'Άρθρο'}
        actions={<Btn onClick={()=>{props.showForm(0,false)}}>Λίστα</Btn>}
      >

        {isLoading && (
          <div className="chx-sk">
            <div className="skeleton chx-sk-line"></div>
            <div className="skeleton chx-sk-line chx-sk-short"></div>
          </div>
        )}

        {!isLoading && (
          <form className="chx-form" onSubmit={save}>

            {note && (
              <div className={note.tone==='crit' ? 'chx-note chx-note-crit' : 'chx-note chx-note-good'} role="status">
                <span className="chx-note-text">{note.text}</span>
              </div>
            )}

            <div className="chx-fields">

              <div className="chx-field">
                <label className="chx-label" htmlFor="chf-type">Τύπος Άρθρου</label>
                <select
                  id="chf-type"
                  className="chx-select"
                  value={val(record.IsChallenge)}
                  onChange={(e)=>setRecord({...record,IsChallenge:e.target.value})}
                >
                  <option value='1'>Challenge</option>
                  <option value='0'>Απλή Ανάρτηση</option>
                </select>
              </div>

              <div className="chx-field">
                <label className="chx-label" htmlFor="chf-sport">Άθλημα</label>
                <select
                  id="chf-sport"
                  className="chx-select"
                  required
                  value={val(record.SportID)}
                  onChange={(e)=>setRecord({...record,SportID:e.target.value})}
                >
                  <option value=''>[Επιλέξτε Άθλημα]</option>
                  {sportsList}
                </select>
              </div>

              <div className="chx-field">
                <label className="chx-label" htmlFor="chf-active">Ενεργό</label>
                <select
                  id="chf-active"
                  className="chx-select"
                  value={val(record.IsActive)}
                  onChange={(e)=>setRecord({...record,IsActive:e.target.value})}
                >
                  <option value='1'>ΝΑΙ</option>
                  <option value='0'>ΟΧΙ</option>
                </select>
              </div>

              <div className="chx-field chx-field-wide">
                <label className="chx-label" htmlFor="chf-title">
                  Τίτλος {isChallenge ? 'Challenge' : 'Άρθρου'}
                </label>
                <input
                  id="chf-title"
                  className="chx-input"
                  type="text"
                  required
                  value={val(record.Title)}
                  onChange={(e)=>setRecord({...record,Title:e.target.value})}
                />
              </div>

              <div className="chx-field chx-field-wide">
                <label className="chx-label" htmlFor="chf-descr">Περιγραφή</label>
                <textarea
                  id="chf-descr"
                  className="chx-textarea"
                  rows={4}
                  value={val(record.Descr)}
                  onChange={(e)=>setRecord({...record,Descr:e.target.value})}
                />
              </div>

            </div>

            {record.IsChallenge>0 && (
              <div className="chx-group">
                <div className="chx-group-head">
                  <span className="chx-group-title">Διάρκεια</span>
                  <span className="chx-group-note">Μόνο για Challenges — ημερομηνία και ώρα έναρξης και λήξης.</span>
                </div>

                <div className="chx-fields chx-fields-2">

                  <div className="chx-field">
                    <span className="chx-label">Από</span>
                    <div className="chx-pair">
                      <input
                        className="chx-input"
                        type="date"
                        required
                        aria-label="Ημερομηνία από"
                        value={val(record.DateFrom)}
                        onChange={(e)=>setRecord({...record,DateFrom:e.target.value})}
                      />
                      <input
                        className="chx-input"
                        type="time"
                        required
                        aria-label="Ώρα από"
                        value={val(record.TimeFrom)}
                        onChange={(e)=>setRecord({...record,TimeFrom:e.target.value})}
                      />
                    </div>
                  </div>

                  <div className="chx-field">
                    <span className="chx-label">Έως</span>
                    <div className="chx-pair">
                      <input
                        className="chx-input"
                        type="date"
                        required
                        aria-label="Ημερομηνία έως"
                        value={val(record.DateTo)}
                        onChange={(e)=>setRecord({...record,DateTo:e.target.value})}
                      />
                      <input
                        className="chx-input"
                        type="time"
                        required
                        aria-label="Ώρα έως"
                        value={val(record.TimeTo)}
                        onChange={(e)=>setRecord({...record,TimeTo:e.target.value})}
                      />
                    </div>
                  </div>

                </div>
              </div>
            )}

            {confirming && (
              <div className="chx-confirm" role="alertdialog" aria-label="Επιβεβαίωση διαγραφής">
                <span className="chx-confirm-text">ΔΙΑΓΡΑΦΗ ΟΛΟΥ ΤΟY CHALLENGE!!!! ΣΙΓΟΥΡΑ???</span>
                <span className="chx-confirm-act">
                  <Btn onClick={()=>setConfirming(false)}>Άκυρο</Btn>
                  <Btn className="chx-btn-crit" onClick={deleteRecord}>Ναι, διαγραφή</Btn>
                </span>
              </div>
            )}

            <div className="chx-actions chx-actions-spread">
              {props.id!=0
                ? <Btn className="chx-btn-crit" onClick={()=>setConfirming(true)} disabled={confirming}>Διαγραφή</Btn>
                : <span></span>}

              <span className="chx-actions-right">
                <Btn onClick={()=>{props.showForm(0,false)}}>Άκυρο</Btn>
                <Btn type="submit" variant="accent" disabled={saving}>
                  {saving ? 'Αποθήκευση…' : 'Αποθήκευση'}
                </Btn>
              </span>
            </div>

          </form>
        )}
      </Panel>

      {props.id!=0 && (
        <Panel title="Φωτογραφία" subtitle="Εικόνα εξωφύλλου της καταχώρησης">
          <div className="chx-upload">
            <FileUpload  id={props.id} type="1" Photo={record.Photo} loadData={loadData} record={record}/>
          </div>
        </Panel>
      )}

      {props.id!=0 && record.IsChallenge==2 && (
        <Panel title="Λογότυπο Χορηγού">
          <div className="chx-upload">
            <FileUpload  id={props.id} type="2" Photo={record.SponsorLogo} loadData={loadData} record={record}/>
          </div>
        </Panel>
      )}

      {props.id!=0 && (
        <ChallengeLang id={props.id} IsChallenge={record.IsChallenge}/>
      )}

      {props.id!=0 && (
        <ChallengeVideos id={props.id} IsChallenge={record.IsChallenge}/>
      )}

      {props.id!=0 && record.IsChallenge==1 && (
        <ChallengeUsers id={props.id} IsChallenge={record.IsChallenge}/>
      )}

    </div>

  )
}
